import $ from "jquery"
import Hook from "../hook"

/** WindowControlsHook hook */
class WindowControlsHook extends Hook {
  async afterRender(window) {
   if (!window.parent) {
      if (window.fullScreenSubWindow) {
        $(window.element).addClass("window-fill-canvas")
     }
    }
  }

  async afterPaginate(window) {
    if (window.parent) {
      if (!window.parent.pageIndexPerTab) {
        window.parent.pageIndexPerTab = new Array(window.parent.tabs.length)
      }

      let tabIndex = 0
      for (let tab of window.parent.tabs || []) {
        if (tab.Selected) {
          window.parent.pageIndexPerTab[tabIndex] = window.input.Data.PageNumber
          break
        }
        tabIndex++
      }
    }
  }
}

export default [
  new WindowControlsHook(),
]